<script>
export default {
  props: {
    name: {type: String, required: true},
    imageUrl: {type: String, default: null},
    jobTitle: {type: String, default: ''},
    company: {type: String, default: ''},
    subtitle: {type: String, default: ''},
    to: {type: [String, Object], default: null},
  },
}
</script>

<template>
  <component :is="to ? 'router-link' : 'div'" :to="to" class="person-thumb">
    <div class="d-flex align-items-center" style="gap: 15px">
      <img v-if="imageUrl"
           width="60" height="60" style="object-fit: cover"
           class="rounded-circle"
           :src="imageUrl" />
      <i v-else class="bi bi-person-circle" style="font-size: 60px; color: #adb5bd;"></i>
      <div>
        <div class="font-weight-bold">{{ name }}</div>
        <p v-if="jobTitle || subtitle" class="text-muted mb-0">
          <small>{{ jobTitle }}</small>
          <small v-if="subtitle"><br>{{ subtitle }}</small>
        </p>
        <div v-if="company">{{ company }}</div>
      </div>
    </div>
  </component>
</template>

<style scoped>
.person-thumb { text-decoration: none; }
</style>
